import { render, staticRenderFns } from "./registroOfertaModal.vue?vue&type=template&id=7b1e1652&"
import script from "./registroOfertaModal.vue?vue&type=script&lang=js&"
export * from "./registroOfertaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports